/**
 * Toasts render above every overlay but outside it: to a dialog or drawer, a click on one — closing it
 * with its X — is a click outside, which would dismiss it. Overlays check this to let it through.
 */
export const isToastInteraction = (event: Event) =>
  event.target instanceof Element && event.target.closest("[data-sonner-toaster]") !== null;
